import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';

const HelpWidgetOption = ({ icon, hintText, isActive, onTouchTap, ...props }) => {
  const Icon = (<FloatingActionButton zDepth={1}
    onTouchTap={onTouchTap}
    mini
    disabled={!isActive}
    {...props}
  >
    {icon}
  </FloatingActionButton>);
  return hintText ? <div aria-label={hintText} className="hint--left" >{Icon}</div> : Icon;
};


export default HelpWidgetOption;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/help-widget-option.jsx